import {
  GET_ORGANIZATION,
  GET_GOAL,
  GET_IMPACT,
  GET_KNOWLEDGE,
  GET_KNOWLEDGE_MAP,
  GET_KNOWLEDGE_COUNT,
  GET_KNOWLEDGE_CHART,
  GET_KNOWLEDGE_RESULT,
  GET_NEWKNOWLEDGE_RESULT,
  GET_INNOVATIONS_RESULT,
  GET_RESULT_ONE,
  GET_GOAL_MAP,
  GET_GOAL_COUNT,
  GET_GOAL_CHART,
  GET_BCG_RESULT,
  GET_SDGS_RESULT,
  GET_CURVE_RESULT,
  GET_CLUSTER_RESULT,
  GET_IMPACT_MAP,
  GET_IMPACT_COUNT,
  GET_IMPACT_CHART,
  GET_ECONOMY_RESULT,
  GET_SOCIETY_RESULT,
  GET_CULTURE_RESULT,
  GET_ENVIRONMENT_RESULT,
  GET_NEWKNOWLEDGE_MAP,
  GET_NEWKNOWLEDGE_COUNT,
  GET_NEWKNOWLEDGE_CHART,
} from "../types";

const initialState = {
  organization: [],
  knowledge: [],
  knowledgeMap: {},
  knowledgeCount: {},
  knowledgeChart: [],

  knowledgeResult: [],
  newknowledgeResult: [],
  innovationsResult: [],

  goal: [],
  bcgResult: [],
  sdgResult: [],
  curveResult: [],
  clusterResult: [],

  impact: [],
  economyResult: [],
  socialResult: [],
  culturalResult: [],
  environmentResult: [],

  resultOne: [],
};

export default function reducerhome(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ORGANIZATION:
      return { ...state, organization: payload };
    case GET_KNOWLEDGE:
      return { ...state, knowledge: payload };
    case GET_IMPACT:
      return { ...state, impact: payload };
    case GET_GOAL:
      return { ...state, goal: payload };

    // Knowledge
    case GET_KNOWLEDGE_MAP:
      return { ...state, knowledgeMap: payload };
    case GET_KNOWLEDGE_COUNT:
      return { ...state, knowledgeCount: payload };
    case GET_KNOWLEDGE_CHART:
      return { ...state, knowledgeChart: payload };

    case GET_KNOWLEDGE_RESULT:
      return { ...state, knowledgeResult: payload };
    case GET_NEWKNOWLEDGE_RESULT:
      return { ...state, newknowledgeResult: payload };
    case GET_INNOVATIONS_RESULT:
      return { ...state, innovationsResult: payload };

    // Goal
    case GET_GOAL_MAP:
      return { ...state, knowledgeMap: payload };
    case GET_GOAL_COUNT:
      return { ...state, knowledgeCount: payload };
    case GET_GOAL_CHART:
      return { ...state, knowledgeChart: payload };

    case GET_BCG_RESULT:
      return { ...state, bcgResult: payload };
    case GET_SDGS_RESULT:
      return { ...state, sdgResult: payload };
    case GET_CURVE_RESULT:
      return { ...state, curveResult: payload };
    case GET_CLUSTER_RESULT:
      return { ...state, clusterResult: payload };

    // Impact
    case GET_IMPACT_MAP:
      return { ...state, knowledgeMap: payload };
    case GET_IMPACT_COUNT:
      return { ...state, knowledgeCount: payload };
    case GET_IMPACT_CHART:
      return { ...state, knowledgeChart: payload };

    case GET_ECONOMY_RESULT:
      return { ...state, economyResult: payload };
    case GET_SOCIETY_RESULT:
      return { ...state, socialResult: payload };
    case GET_CULTURE_RESULT:
      return { ...state, culturalResult: payload };
    case GET_ENVIRONMENT_RESULT:
      return { ...state, environmentResult: payload };

    // NEWKnowledge
    case GET_NEWKNOWLEDGE_MAP:
      return { ...state, knowledgeMap: payload };
    case GET_NEWKNOWLEDGE_COUNT:
      return { ...state, knowledgeCount: payload };
    case GET_NEWKNOWLEDGE_CHART:
      return { ...state, knowledgeChart: payload };

    case GET_RESULT_ONE:
      return { ...state, resultOne: payload };

    default:
      return state;
  }
}
